import axios from "axios";
import { Machine } from "xstate";
import { assign, log, sendParent } from "xstate/lib/actions";

// An XState state machine that handles loading a single chunk of grid cell data.
// This reaches a terminal state once the data is loaded, but we aren't currently
// doing anything to clean them up.

const cellsMachine = Machine(
    {
        id: "cells",
        initial: "waiting",
        states: {
            // We expect this machine to be spawned as a child of a row machine,
            // and to know the column window at creation time. But the row may not
            // have resolved its row ids yet, in which case we wait.
            waiting: {
                entry: log(context => context, "cellMachine"),
                always: { target: "loading", cond: "haveRowIDs" },
                on: {
                    ROW_IDS: { target: "loading", actions: "receiveRowIDs" }
                }
            },
            // When we have row ids we load the cells.
            loading: {
                entry: log(context => context, "cellMachine loading"),
                invoke: {
                    src: "getCells",
                    onDone: { target: "ready", actions: "sendCells" },
                    onError: "error"
                }
            },
            error: {},
            ready: {}
        }
    },
    {
        actions: {
            receiveRowIDs: assign({
                rowIDs: (context, event) => event.rowIDs
            }),
            sendCells: sendParent(({ rowIDs, columnWindow }, { data: { cells } }) => ({
                type: "CELLS",
                cells: rowIDs.reduce((acc, id, index) => ({ ...acc, [index]: cells[id] }), {}),
                columnWindow
            }))
        },
        guards: {
            haveRowIDs: context => !!context.rowIDs
        },
        services: {
            getCells: (
                { accountID, podcastID, report, period, feedFilter, columnWindow, rowIDs },
                event
            ) =>
                axios({
                    method: "post",
                    url: `/api/${accountID}/measurement/reports/${podcastID}/${report}/${period}/cells/${columnWindow}`,
                    params: {
                        feedFilter
                    },
                    data: rowIDs
                }).then(({ data }) => data)
        }
    }
);

export default cellsMachine;
